<template>
  <div>
    a115 api
  </div>
</template>

<script>
import api from "@/services/api";
import apiEndpoints from "@/services/apiEndpoints";

export default {
  data() {
    return {
      order: {
        orderNo: "2020090101000001",
      },
    };
  },
  async created() {
    await this.getPriceCod();
    await this.cashOnDeliverySettlement();
  },

  methods: {
    async getPriceCod() {
      console.log("getPriceCod");
      let { status, data } = await api.post(apiEndpoints.getCashOnDelivery, {
        orderNo: this.order.orderNo,
      });
      console.log("status", status);
      console.log("data", data);
      if (status && status === 200) {
        this.calculationInformation = this.preCalculate(
          data.calculationInformation
        );
      }
    },

    preCalculate(d) {
      return d;
    },

    async cashOnDeliverySettlement() {
      console.log("cashOnDeliverySettlement");
      let orderNo = "2020090101000001";
      let printOrder = "PRINT";
      let settlePrice = 10000;
      let totalConsumptionTax = 1000;
      let settleDate = "2020/09/01";

      let { status, data } = await api.post(
        apiEndpoints.cashOnDeliverySettlement,
        {
          orderNo,
          printOrder,
          settlePrice,
          totalConsumptionTax,
          settleDate,
        }
      );
      console.log("status", status);
      console.log("data", data);
      if (status && status === 200) {
        console.log(data);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
